import React, { Component } from "react";
import { MedBoxPicker } from "../../../../PickerOrder/PickerOrderPage/PickerOrderPage.styled";
import { Empty, Tag } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

export class PickerMedBatches extends Component {
  render() {
    let { selectedMed } = this.props;

    return (
      <>
        {selectedMed ? (
          selectedMed?.batches?.length > 0 ? (
            <MedBoxPicker>
              <p className="title">Batch Number</p>
              <p className="title">Quantity</p>
              {/*
            ---------------------- first check weather any nearbyExp date flag is true
            ---------------------- then remove that from list then sort according to nearest expiry date
            */}
              {selectedMed?.batches
                ?.filter((el) => !el?.expiryNearBy)
                ?.map((item, pos) => {
                  return (
                    <div
                      className={`batchList ${
                        item?.isBatchBlocked ? "blocked" : ""
                      }`}
                      key={pos}
                    >
                      <p>
                        {item?.batch_number}
                        {item?.isBatchBlocked ? (
                          <Tag icon={<CloseCircleOutlined color="error" />}>
                            Batch blocked!
                          </Tag>
                        ) : null}
                      </p>
                      <p>{item?.quantity}</p>
                    </div>
                  );
                })}
            </MedBoxPicker>
          ) : null
        ) : // (
        //   <Empty
        //     style={{ margin: "10vh 0" }}
        //     description="No Batches found"
        //   />
        // )
        null}
      </>
    );
  }
}

export default PickerMedBatches;
